import { AppContext, AppContextType } from '@/AppContext'
import { useContext } from 'react'
import { AppSettings } from './AppSettings'
import CrossPlatformDialog from '@/dialogs/components/CrossPlatformDialog'

export function AppSettingsDialog() {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType

    const { showAboutDialog } = appState.appState

    const onClose = () => {
        appDispatch({
            type: 'update_app_state',
            value: { showAboutDialog: null },
        })
    }

    if (!showAboutDialog) {
        return null
    }

    return (
        <CrossPlatformDialog
            frameName="Dialog:AppSettingsDialog"
            classNameNative="min-w-[720px]"
            classNameBrowser="w-full md:w-[720px] max-h-[720px] h-[90vh]"
            forceBrowserModal
            onDefaultClose={onClose}
            title="Settings"
            overflow={false}
        >
            <AppSettings startingPage={showAboutDialog.startingPage} />
        </CrossPlatformDialog>
    )
}
